<template>
  <div id="couponbox">
    <el-dialog :close-on-click-modal="false" :title="$fanyi('选择优惠券')" :visible.sync="couponDetailDialogVisible"
      :append-to-body="true" custom-class="couponDetailDialog" width="480px" :center="true" :before-close="handleClose">
      <div class="couponcontent" v-loading="loanding">
        <!-- 代金券/优惠劵-->
        <div class="couponitem"
          :class="{ activebgc: item.checked == true && item.type == 10, deliveryListactivebgc: item.checked == true && item.type == 30, IsitavailableActive: item.type == 30 && Isitavailable(item) }"
          @click="updateCouponActiveStatus(item)" v-for="(item, index) in couponList" :key="index">
          <div class="header">
            <div v-if="item.type == 10" class="coupon">{{ $fanyi('优惠券') }}</div>
            <div v-if="item.type == 30" class="Voucher"> {{ Isitavailable(item) ? $fanyi('不可用') : $fanyi('代金券') }}</div>
            <div class="no">
              No. {{ item.number }}
            </div>
          </div>

          <div class="content">
            <h1>{{ item.title }} </h1>
            <img v-if="item.type == 10" src="@/assets/newassets/coupon/Coupons.svg" alt="">
            <img v-if="item.type == 30 && !Isitavailable(item)" src="@/assets/newassets/coupon/Vouchers.svg" alt="">
            <img v-if="item.type == 30 && Isitavailable(item)" src="@/assets/newassets/coupon/Vouchers1.svg" alt="">
          </div>
          <div class="footer">
            <p class="Orderamount">
              <span v-if="item.type == 30 && item.status == 10">{{ $fanyi('订单金额') }} > ₴{{ item.restrictions
                }}</span>
            </p>
            <p>
              {{ $fanyi('有效期') }}:<br />{{ item.free_datetime_start }}--
              {{ item.free_datetime_end }}
            </p>
          </div>
        </div>
        <div class="noadata" v-if="noadata">
          <div class="img-box">
            <img src="../../../../../../assets/defaulticon/coupon.svg" alt="">
          </div>

          <div class="notext">
            {{ type == 'order' ? $fanyi('暂无可用优惠券') : $fanyi('暂无可用代金券') }}
          </div>
        </div>
      </div>

      <div class="promptText">
        {{
          $fanyi(
            "温馨提示：一个订单只能使用一张优惠券，优惠券适用于订单、代金券适用于配送单"
          )
        }}
      </div>
      <span slot="footer" class="dialog-footer">

        <el-button type="primary" @click="confirmed">{{ $fanyi('确认') }}</el-button>
        <el-button @click="cancel">{{ $fanyi('取消使用') }}</el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      form: {
        page: 1,
        pageSize: 9999999,

      },
      couponList: [],
      couponDetailDialogVisible: false,
      loanding: false,
      noadata: false,
      type: 'order', // 订单还是配送单
      couponitem: '',// 选中的优惠劵
      amountprice: 0,// 配送单价格
    };
  },


  methods: {

    handleClose() {
      this.couponDetailDialogVisible = false;
    },
    // 获取数据
    getData() {
      this.$api
        .couponGet(this.form)
        .then((res) => {
          this.loanding = false
          if (this.type == 'order') {
            // 优惠劵
            this.couponList = res.data.data.filter((item) => item.type != 30);
          } else {
            // 代金券
            this.couponList = res.data.data.filter((item) => item.type == 30);


          }
          if (this.couponList.length == 0) {
            this.noadata = true
          } else {
            this.noadata = false
          }



          this.couponList.forEach((item) => {
            item.free_datetime_start = item.free_datetime_start.substr(0, 10);
            item.free_datetime_end = item.free_datetime_end.substr(0, 10);
            item.checked = false;
          });



          // this.$forceUpdate();
        })
        .catch((err) => { });

    },
    Isitavailable(item) {

      let flag = false
      if (this.type == 'deliveryorder') {
        if (this.amountprice <= item.restrictions) {
          flag = true
        }
      }
      return flag
    },
    // 打开优惠劵
    open(ordertype, price) {
      // 订单类型。订单还是配送单
      this.couponDetailDialogVisible = true
      this.type = ordertype
      if (ordertype == 'deliveryorder') {

        this.amountprice = Number(price)
      }
      if (this.couponList.length == 0) {
        this.loanding = true
        this.getData()
      }

    },
    confirmed() {
      // 取消清空优惠劵id
      if (this.couponitem !== '') {
        this.$emit('Usecoupons', this.couponitem);
      } else {
        this.$emit('Usecoupons', '');
      }
      this.couponDetailDialogVisible = false;
    },
    //更新优惠券选中状态
    updateCouponActiveStatus(item) {
      // 判断优惠劵是否达到使用额度
      if (this.type == 'deliveryorder') {
        // 代金券使用，配送单金额必须大于代金券使用额度
        if (this.amountprice <= item.restrictions) {
          console.log(this.amountprice <= item.restrictions);
          return
        }
      }
      this.couponList.forEach((arrTypeItem) => {
        arrTypeItem.checked = false;
      });
      item.checked = !item.checked;

      if (item.checked) {
        this.couponitem = item
      } else {
        this.couponitem = ''
      }
      this.$forceUpdate();

    },
    cancel() {
      // 取消清空优惠劵id
      this.$emit('Usecoupons', '');
      this.couponDetailDialogVisible = false;
      this.couponList.forEach((arrTypeItem) => {
        arrTypeItem.checked = false;
      });
      this.couponitem = ''
    }
  },
};
</script>
<style></style>
<style lang="scss" scoped>
/deep/.couponDetailDialog {
  position: relative;
  width: 480px;
  height: 630px;

  border-radius: 20px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 40px 30px;


  .couponcontent {
    padding-top: 2px;
    width: 100%;
    height: 360px;
    overflow-x: hidden;
    overflow-y: auto;


    display: flex;
    flex-direction: column;

    align-items: center;


    .couponitem {
      width: 400px;

      min-height: 360px;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.1);
      border-radius: 20px;
      padding: 30px;
      margin-bottom: 30px;

      &:last-child {
        margin-bottom: 10px;
      }

      &:hover {
        cursor: pointer;
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        margin-bottom: 35px;

        .Voucher {
          min-width: 140px;
          height: 30px;
          padding: 0px 8px;
          background: #E8EDFA;
          border-radius: 8px;
          font-weight: 500;
          font-size: 14px;
          color: #2052CE;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .coupon {
          min-width: 140px;
          height: 30px;
          padding: 0px 8px;
          background: #F2E8FB;
          border-radius: 8px;
          font-weight: 500;
          font-size: 14px;
          color: #841DD3;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .no {
          font-weight: 500;
          font-size: 14px;
          color: #121212;
          line-height: 20px;
        }
      }

      .content {
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;
        min-height: 154px;

        h1 {
          width: 100%;
          font-weight: bold;
          font-size: 40px;
          color: #121212;

          min-height: 50px;
          text-align: center;
          margin-bottom: 26px;

          overflow: hidden;
        }

        img {
          width: 36px;
          height: 36px;
        }
      }

      .footer {
        p {
          font-weight: 500;
          font-size: 14px;
          color: #121212;
          line-height: 20px;
          min-height: 20px;

          &:first-child {
            margin-bottom: 15px;
          }
        }
      }
    }

    .noadata {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 360px;

      .img-box {
        width: 160px;
        height: 160px;
        margin-bottom: 36px;

        img {
          width: 100%;
          height: 100%;
        }

      }

      .notext {
        font-weight: normal;
        font-size: 24px;
        color: #121212;
        line-height: 20px;
      }
    }

    .activebgc {
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.1);
      border-radius: 20px;
      border: 2px solid #963FDA !important;
    }

    .deliveryListactivebgc {

      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.1);
      border-radius: 20px;
      border: 2px solid #2052CE !important;
    }

    .IsitavailableActive {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.1);
      border-radius: 20px;

      * {
        color: #999999 !important;
      }

      .Voucher {
        background: #F5F5F5 !important;
      }

      cursor: not-allowed !important;
    }
  }

  .el-dialog__header {
    height: 45px;
    padding: 0px;
    display: flex;
    font-weight: normal;
    font-size: 16px;
    color: #121212;
    line-height: 20px;



    .el-dialog__headerbtn {
      right: 20px;
      top: 30px;

      .el-dialog__close {
        font-weight: 600;
        font-size: 18px;
        color: #000;
      }
    }
  }

  .el-dialog__footer {

    padding: 0px;

    display: flex;
    justify-content: center;

    .dialog-footer {
      display: flex;

      .el-button {

        &:first-child {
          min-width: 120px;
          height: 40px;

          background: #D12A1D;
          padding: 0 15px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;

          font-weight: 400;
          font-size: 14px;
          color: #FFFFFF;
        }

        &:last-child {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 120px;
          padding: 0 15px;
          margin-left: 20px;
          height: 40px;
          background: #FFFFFF;
          color: #222222;
          border-radius: 10px;
          border: 1px solid #DFDFDF;

          &:hover {
            color: #222222;
          }
        }
      }
    }


  }

  .promptText {
    padding-top: 25px;
    font-weight: 400;
    font-size: 12px;
    color: #D12A1D;
    line-height: 14px;
    margin-bottom: 30px;
  }

  .el-dialog__body {
    padding: 0px;
  }


}
</style>
